var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"b-checkbox-group",class:{'b-checkbox-button-group' : _vm.type==='button'}},[(_vm.type==='button' && _vm.tips)?_c('h4',{staticClass:"tips"},[_vm._v(_vm._s(_vm.tips))]):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70d65e1b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/checkbox/src/checkbox-group.vue
// module id = 0Jnq
// module chunks = 2